import choVayConst from "constants/choVayConst";
import { LaiSuatText } from "constants/choVayConst";
import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { getDate } from "utils/formatDate";
import { formatNumber2 } from "utils/currencyFormat";
import QuanLyThuChiHopDongApi from "service/quanLyThuChiHopDongApi";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
export const LanDongLaiSub = ({ data, showPhiPhat, soNgayQuanHan }) => {
  const [pageLanDongLaiSub, setPageLanDongLaiSub] = useState(1);
  const [totalRowSub, setTotalRowSub] = useState(0);
  const [listThanhToan, setListThanhToan] = useState([]);
  const [dataLichSuDongLai, setDataLichSuDongLai] = useState([]);
  useEffect(() => {
    LoadData(1);
  }, []);

  const LoadData = (pageNumber) => {
    QuanLyThuChiHopDongApi.listthuchilandonglai(
      data.ChoVayId,
      pageNumber,
      10
    ).then((response) => {
      setListThanhToan(response.data.List);
      setDataLichSuDongLai(response.data);
      setPageLanDongLaiSub(pageNumber);
      setTotalRowSub(response.data.TotalQuantity);
    });
  };
  const handlePageChange = (pageNumber) => {
    LoadData(pageNumber);
  };

  return (
    <>
      <div
        class="table-responsive table-responsive-new table-new1  table-rounded"
        style={{ color: "#363636", marginTop: "10px" }}
      >
        <div class="custom-table-wrapper custom-border-mm">
          <div class="table-headers">
            <div class="custom-table-header flex-basis-5">
              <span class="color-do-bold">
                [ {dataLichSuDongLai.TotalQuantity} ]<br />
                &nbsp;
              </span>
            </div>
            <div class="custom-table-header flex-basis-10">
              <p class="text-center">
                Thời gian
                <br />
                &nbsp;
              </p>
            </div>
            <div class="custom-table-header flex-basis-10">
              <p class="text-right">
                Tiền thanh toán
                <br />
                <span class="color-do-bold">
                  {formatNumber2(dataLichSuDongLai.TotalTienThu)}
                </span>
              </p>
            </div>
            <div class="custom-table-header flex-basis-10">
              <p class="text-right">
                Phí khác
                <br />
                <span class="color-do-bold">
                  {formatNumber2(dataLichSuDongLai.TotalPhiKhac)}
                </span>
              </p>
            </div>
            {dataLichSuDongLai.IsPhiKho === 1 && data.Type == 3 && (
              <div class="custom-table-header flex-basis-10">
                <p class="text-right">
                  Phí kho
                  <br />
                  <span class="color-do-bold">
                    {formatNumber2(dataLichSuDongLai.TotalPhiKho)}
                  </span>
                </p>
              </div>
            )}
            {showPhiPhat && (
              <div class="custom-table-header flex-basis-10">
                <p class="text-right">
                  Phí phạt
                  <br />
                  <span class="color-do-bold">
                    {formatNumber2(dataLichSuDongLai.TotalPhiPhat)}
                  </span>
                </p>
              </div>
            )}

            <div class="custom-table-header flex-basis-10">
              <p class="text-right">
                Tổng thanh toán
                <br />
                <span class="color-do-bold">
                  {formatNumber2(
                    dataLichSuDongLai.TotalTienThu +
                      dataLichSuDongLai.TotalPhiKhac +
                      dataLichSuDongLai.TotalPhiKho +
                      dataLichSuDongLai.TotalPhiPhat
                  )}
                </span>
              </p>
            </div>
            <div class="custom-table-header  flex-basis-15">
              <p class="text-center">
                Ghi chú <br />
                &nbsp;
              </p>
            </div>
          </div>
          <div class="custom-table-body">
            {listThanhToan &&
              listThanhToan.map((item, index) => (
                <>
                  <div class="custom-table-row">
                    <div class="custom-table-cell username-cell flex-basis-5 disk-mobile">
                      <span class="mobile-column-name">STT</span>
                      <div class="center-wrapper">
                        <p class="text-center">{item.IndexId}</p>
                      </div>
                    </div>
                    <div class="row-show-three">
                      <div class="row-mobile">
                        <div class="custom-table-cell flex-basis-10  disk-mobile">
                          <span class="mobile-column-name">Thời gian</span>
                          <div class="center-wrapper">
                            <p class="icon-dropdown-mobile text-center">
                              <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                              {getDate(item.Time)}
                            </p>
                          </div>
                        </div>
                        <div class="custom-table-cell flex-basis-10   disk-mobile">
                          <span class="mobile-column-name ">
                            Tiền thanh toán
                          </span>
                          <div class="center-wrapper">
                            <p class="text-right1">
                              {formatNumber2(item.Value)}
                            </p>
                          </div>
                        </div>
                        <div class="custom-table-cell flex-basis-10 disk-mobile">
                          <span class="mobile-column-name ">Phí khác</span>
                          <div class="center-wrapper">
                            <p class="text-right1">
                              {formatNumber2(item.OtherFee)}
                            </p>
                          </div>
                        </div>
                        {dataLichSuDongLai.IsPhiKho === 1 && data.Type == 3 && (
                          <div class="custom-table-cell flex-basis-10  disk-mobile">
                            <span class="mobile-column-name">Phí kho</span>
                            <div class="center-wrapper">
                              <p class="text-right1">
                                {formatNumber2(item.PhiKho)}
                              </p>
                            </div>
                          </div>
                        )}
                        {showPhiPhat && (
                          <div class="custom-table-cell flex-basis-10  disk-mobile">
                            <span class="mobile-column-name">Phí phạt</span>
                            <div class="center-wrapper">
                              <p class="text-right1">
                                {formatNumber2(item.Amercement)}
                              </p>
                            </div>
                          </div>
                        )}
                        <div class="custom-table-cell flex-basis-10  disk-mobile">
                          <span class="mobile-column-name">
                            Tổng thanh toán
                          </span>
                          <div class="center-wrapper">
                            <p class="text-right1">
                              {formatNumber2(
                                item.Value +
                                  item.OtherFee +
                                  item.PhiKho +
                                  item.Amercement
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="form-row-detail content12">
                        <div class="custom-table-cell flex-basis-15  disk-mobile">
                          <span class="mobile-column-name">Ghi chú</span>
                          {!soNgayQuanHan && (
                            <div class="center-wrapper">{item.Note}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
          </div>
        </div>
      </div>
      <div class="footer-page-new">
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <div class="paniation-new d-flex just-end">
              <nav aria-label="Page navigation">
                <Pagination
                  activePage={pageLanDongLaiSub}
                  itemsCountPerPage={10}
                  totalItemsCount={totalRowSub}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  itemClass="page-item border-none"
                  linkClass="page-link border-none"
                  activeClass="active"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
